"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Container = void 0;
var _react = _interopRequireWildcard(require("react"));
var _state = require("../../../../../../../state");
var _Component = require("./Component");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var Container = function Container(_ref) {
  var isOpen = _ref.isOpen,
    toggle = _ref.toggle;
  var _useDisableTotp = (0, _state.useDisableTotp)(),
    disableTotpState = _useDisableTotp.disableTotpState,
    disableTotp = _useDisableTotp.disableTotp,
    resetDisableTotp = _useDisableTotp.resetDisableTotp;
  (0, _react.useEffect)(function () {
    if (disableTotpState.done) {
      resetDisableTotp();
    }
  }, [disableTotpState.done]);
  return /*#__PURE__*/_react.default.createElement(_Component.Component, {
    isOpen: isOpen,
    toggle: toggle,
    submitLoading: disableTotpState.loading,
    onSubmit: function onSubmit(_ref2) {
      var code = _ref2.code;
      return disableTotp(code);
    }
  });
};
exports.Container = Container;